import { LOAD_ORDER_SUCCESS } from 'dux/checkoutOrder/actionTypes';
import {
  CREATE_SUBSCRIPTION_SUCCESS,
  UPDATE_SUBSCRIPTION_SUCCESS,
} from 'dux/subscriptions/actionTypes';
import { COMPLETE_HAIR_PROFILE, SAVE_ANSWER_SUCCESS } from 'dux/consultation/actionTypes';

import * as paymentMethodsStatuses from 'constants/paymentMethodsStatuses';
import * as statuses from 'constants/statuses';
import * as recommendationsStatus from './constants/recommendationsStatus';
import {
  ADDRESSES_FAILURE,
  ADDRESSES_REQUEST,
  ADDRESSES_SUCCESS,
  CLEAR_REFERRAL_CODE,
  CREATE_ADDRESS_SUCCESS,
  CREATE_PAYMENT_METHOD_SUCCESS,
  PATCH_USER_FAILURE,
  PATCH_USER_REQUEST,
  PATCH_USER_SUCCESS,
  PAYMENT_METHODS_FAILURE,
  PAYMENT_METHODS_REQUEST,
  PAYMENT_METHODS_SUCCESS,
  RECOMMENDATIONS_FAILURE,
  RECOMMENDATIONS_REQUEST,
  RECOMMENDATIONS_SUCCESS,
  SET_CUSTOMER_ORIGIN,
  SET_LIVECHAT_GENERATION,
  SET_LIVECHAT_OPENING,
  SET_REFERRAL_CODE,
  SET_USER_COUNTRY,
  SUPPLEMENTS_VARIANT_FETCH_ERROR,
  SUPPLEMENTS_VARIANT_FETCH_REQUEST,
  SUPPLEMENTS_VARIANT_FETCH_SUCCESS,
  USER_FAILURE,
  USER_REQUEST,
  USER_SUCCESS,
} from './actionTypes';
import getInitialState from './initialState';

export default function userReducer(state = getInitialState(), action) {
  switch (action.type) {
    case USER_REQUEST:
    case PATCH_USER_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: true,
      };

    case USER_SUCCESS:
    case PATCH_USER_SUCCESS:
      return {
        ...state,
        error: null,
        isLoading: false,
        user: action.user,
      };

    case USER_FAILURE:
    case PATCH_USER_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };

    case ADDRESSES_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: true,
        addresses: null,
        addressesStatus: statuses.LOADING,
        addressesError: null,
      };

    case ADDRESSES_SUCCESS:
      return {
        ...state,
        error: null,
        isLoading: false,
        addresses: action.addresses.sort((x, y) => {
          return x.primary === y.primary ? 0 : x.primary ? -1 : 1;
        }),
        addressesStatus: statuses.SUCCESS,
      };

    case ADDRESSES_FAILURE:
      return {
        ...state,
        error: { code: 'unhandled' },
        isLoading: false,
        addressesStatus: statuses.ERROR,
        addressesError: action.error,
      };

    case CREATE_ADDRESS_SUCCESS:
      return {
        ...state,
        addresses: [...state.addresses, action.address],
      };

    case CREATE_PAYMENT_METHOD_SUCCESS:
      if (state.paymentMethods.findIndex(pm => pm.id === action.paymentMethod.id) >= 0) {
        return {
          ...state,
          error: false,
          isLoading: false,
        };
      }
      return {
        ...state,
        error: false,
        isLoading: false,
        paymentMethods: [...state.paymentMethods, action.paymentMethod],
      };

    case PAYMENT_METHODS_SUCCESS:
      return {
        ...state,
        paymentMethodsStatus: paymentMethodsStatuses.SUCCESS,
        paymentMethods: action.paymentMethods,
      };

    case PAYMENT_METHODS_FAILURE:
      return {
        ...state,
        paymentMethodsError: action.error,
        paymentMethodsStatus: paymentMethodsStatuses.ERROR,
      };

    case PAYMENT_METHODS_REQUEST:
      return {
        ...state,
        paymentMethodsError: null,
        paymentMethodsStatus: paymentMethodsStatuses.LOADING,
      };

    case LOAD_ORDER_SUCCESS:
      if (!action.isPayment) {
        return state;
      }

      return {
        ...state,
        referralCode: null,
        user: {
          ...state.user,
          profile: {
            ...state.user.profile,
            has_order: true,
            has_order_with_formulas: true,
            order_count: state.user.profile.order_count + 1,
          },
        },
      };

    case CREATE_SUBSCRIPTION_SUCCESS:
    case UPDATE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          profile: {
            ...state.user.profile,
            has_active_subscription: action.subscription.status === 'active',
          },
        },
      };

    case SAVE_ANSWER_SUCCESS:
      if (action.answers.profile_zipcode) {
        return {
          ...state,
          user: {
            ...state.user,
            zipcode: action.answers.profile_zipcode,
            profile: {
              ...state.user.profile,
            },
          },
        };
      }
      if (action.answers.pref_fragrance || action.answers.pref_fragrance_free) {
        return {
          ...state,
          user: {
            ...state.user,
            profile: {
              ...state.user.profile,
              fragrance: action.answers.pref_fragrance_free
                ? 'FREE'
                : action.answers.pref_fragrance,
              is_fragrance_soldout: false,
            },
          },
        };
      }
      return {
        ...state,
        user: {
          ...state.user,
          profile: {
            ...state.user.profile,
          },
        },
      };

    case COMPLETE_HAIR_PROFILE:
      return {
        ...state,
        user: {
          ...state.user,
          profile: {
            ...state.user.profile,
            hair_profile_status: 'completed',
          },
        },
      };

    case SET_REFERRAL_CODE:
      return {
        ...state,
        referralCode: action.referralCode,
      };
    case CLEAR_REFERRAL_CODE:
      return {
        ...state,
        referralCode: null,
      };
    case SET_CUSTOMER_ORIGIN:
      return {
        ...state,
        user: {
          ...state.user,
          customer_origin: action.customer_origin,
        },
      };

    case RECOMMENDATIONS_REQUEST:
      return {
        ...state,
        recommendationsError: null,
        recommendationsStatus: recommendationsStatus.LOADING,
      };

    case RECOMMENDATIONS_SUCCESS:
      return {
        ...state,
        recommendations: action.recommendations,
        recommendationsStatus: recommendationsStatus.SUCCESS,
      };

    case RECOMMENDATIONS_FAILURE:
      return {
        ...state,
        recommendationsError: action.error,
        recommendationsStatus: recommendationsStatus.ERROR,
      };

    case SUPPLEMENTS_VARIANT_FETCH_REQUEST:
      return {
        ...state,
        supplementsVariant: null,
      };
    case SUPPLEMENTS_VARIANT_FETCH_SUCCESS:
      return {
        ...state,
        supplementsVariant: action.response,
      };
    case SUPPLEMENTS_VARIANT_FETCH_ERROR:
      return {
        ...state,
        supplementsVariant: null,
      };

    case SET_LIVECHAT_GENERATION:
      return {
        ...state,
        hasGeneratedLivechat: action.hasGeneratedLivechat,
      };
    case SET_LIVECHAT_OPENING:
      return {
        ...state,
        hasOpenedLivechat: action.hasOpenedLivechat,
      };

    case SET_USER_COUNTRY:
      return {
        ...state,
        geolocationGuessedCountry: action.geolocationGuessedCountry,
      };

    default:
      return state;
  }
}
